import {
	LOGIN,
	LOGIN_FAILURE,
	LOGIN_GET_SCHOOLS,
	LOGIN_GET_SCHOOLS_FAILURE,
	LOGIN_GET_SCHOOLS_SUCCESS,
	LOGIN_SUCCESS
} from "./actions";

const initialState = {
	loading: false,
	loggedIn: false,
};

export const loginReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				loading: true,
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				loading: false,
				loggedIn: true,
			};
		case LOGIN_FAILURE:
			return {
				...state,
				loading: false,
				loggedIn: false,
			};
		case LOGIN_GET_SCHOOLS:
			return {
				...state,
			};

		case LOGIN_GET_SCHOOLS_SUCCESS:
			return {
				...state,
				schools: action.schools,
			};

		case LOGIN_GET_SCHOOLS_FAILURE:
			return {
				...state,
			};
		default:
			return state;
	}
};